export const cardTheme = {
  root: {
    borderRadius: 'var(--border-radius)',
  },
  title: {
    fontSize: 'var(--one-half-rem)',
  },
  body: {
    padding: 'var(--three-fourth-rem) var(--one-half-rem)',
  },
  colorScheme: {
    light: {
      extend: {
        agility: {
          root: {
            shadow: 'var(--overlay-box-shadow)',
          },
        },
      },
      root: {
        background: 'var(--p-white)',
        color: 'var(--text-color)',
      },
    },
    dark: {
      extend: {
        agility: {
          root: {
            shadow: 'var(--overlay-box-shadow)',
          },
        },
      },
      root: {
        background: 'var(--secondary-background)',
        color: 'var(--text-color)',
      },
    },
  },
  css: ({ dt }: any) => `
    .p-card {
      box-shadow: ${dt('card.agility.shadow')};
    }
  `,
};
